<template>    
    <div class="file-upload">
        <div class="">
            <input  type='file' ref="fileUpload" style="display:none" accept=".pdf,.jpg,.jpeg,.png" multiple @change="Upload">

            <v-btn @click.native.stop :disabled="uploadInProgress as boolean" flat class="btn btn--default-fill btn--sm mr-4"  @click="ShowBrowser">
                <!-- <img src="@assets/images/general/icon-attachment-secondary.svg" alt="Priponka" class="btn-img"/> -->
                Prebrskaj
            </v-btn>
            <span v-show="modelValue.length == 0 && uploadInProgress == false" class="file-upload__info-text">Ni izbranih datotek.</span>
            <span v-show="uploadInProgress" class="file-upload__loader">
                <!-- <img src="@assets/images/general/loader/loader.svg" alt="Loader"> -->
            </span>
        </div>

        <div class="file-upload__files">
            <div v-if="modelValue.length" v-for="file, idx in modelValue">
                
                <div class="file-upload__file">
                    <div> 
                        <span>{{ file.FileName }} </span>
                        <span class="file-upload__size">{{file.FileSize.toString() }} B</span>
                    </div>
                    <img src="@assets/images/general/icon-close.svg" @click="DeleteFile(file.FileId, idx)" class="file-upload__icon-delete" />
                </div>
            </div>
        </div>
    </div>

    <!-- Error msg -->
    
    <div v-if="error" class="v-messages">
        <div class="v-messages__message error">
            {{ errorText![0].$message }}
        </div>
    </div>

    <span v-else-if="internalError" class="v-messages">
        <div class="v-messages__message error">
            {{ internalErrorText }}
        </div>
    </span>

</template>

<script setup lang="ts">
    import { PropType, Ref, ref } from "vue";
    import { IFileData, useFw4Store } from "fw4-library";
    import { commClient } from "fw4-library";
    import { i18n } from "@app/i18n";
    import { ErrorObject } from "@vuelidate/core";

    const fw4 = useFw4Store();

    const props = defineProps({
        modelValue: {
            type: Object as PropType<IFileData[]>,
            required: true
        },
        uploadMethod: {
            type: String,
            default: null
        },
        uploadMethodParams: {
            type: Object as PropType<Record<string, any>>,
            default: {}
        },
        error: {
            type: Boolean,
            default: false
        },
        errorText: {
            type: Object as PropType<ErrorObject[]>,
            default: [],
        }
        // errorText: {
        //     type: String,
        //     default: ""
        // }
    });

    const emit = defineEmits(["update:modelValue"]);
    const fileUpload: any = ref(null);
    var uploadInProgress: Ref<Boolean> = ref(false);
    let internalError: Ref<boolean> = ref(false);
    let internalErrorText: Ref<string> = ref("");
    
    function ShowBrowser(){
        fileUpload.value.value = '';
        fileUpload.value.click();
        internalError.value = false;
    }

    function UploadCallback(Message: any){
        uploadInProgress.value = false;
        
        if(Message.Success === true){
            emit("update:modelValue", [...props.modelValue, ...Message.FileData]);
        }
        else {
            internalError.value = true;
            internalErrorText.value = Message.ErrorMsg ? i18n.global.t("form_upload." + Message.ErrorMsg) : i18n.global.t("form_upload.error_uploading");
        }
    }

    function Upload(e: any){      
        if(e.target.files.length > 0){
            uploadInProgress.value = true;
            commClient.executeMethodUpload(e.target.files, UploadCallback, props.uploadMethod, props.uploadMethodParams); 
        }
    }

    function DeleteFile(fileId: string, fileIndex: number){
        fw4.DeleteFile(fileId)
            .then(() => {        
                let modelValueNew = JSON.parse(JSON.stringify(props.modelValue));
                modelValueNew.splice(fileIndex, 1);
                emit("update:modelValue", modelValueNew);
            })
    }
</script>